import { render, staticRenderFns } from "./EmailorSMSDND.vue?vue&type=template&id=b7d47ae4&scoped=true&"
import script from "./EmailorSMSDND.vue?vue&type=script&lang=js&"
export * from "./EmailorSMSDND.vue?vue&type=script&lang=js&"
import style0 from "./EmailorSMSDND.vue?vue&type=style&index=0&id=b7d47ae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d47ae4",
  null
  
)

export default component.exports